import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { get } from '../services/base';

const SubscripcionContext = createContext();

const SubscripcionContextProvider = ({ children }) => {
  
  const [solicitudes, setSolicitudes] = useState([]);
  const [subscripciones, setSubscripciones] = useState([]);

useEffect(() => {
  const fetchData = async () => {
      const respuestaSolicitudes = await get(`/calendario/solicitudes/yo`);
      const dataSolicitudes = await respuestaSolicitudes.data;
      setSolicitudes(dataSolicitudes);

      const respuestaSubscripciones = await get(`/calendario/subscripciones/yo`);
      const dataSubscripciones = await respuestaSubscripciones.data;
      setSubscripciones(dataSubscripciones);
    };
    fetchData();
  }, []);

  const actualizarInformacion = async () => {
    const respuestaSolicitudes = await get(`/calendario/solicitudes/yo`);
      const dataSolicitudes = await respuestaSolicitudes.data;
      setSolicitudes(dataSolicitudes);

      const respuestaSubscripciones = await get(`/calendario/subscripciones/yo`);
      const dataSubscripciones = await respuestaSubscripciones.data;
      setSubscripciones(dataSubscripciones);
  };

  const contextValue = {
    solicitudes,
    subscripciones,
    actualizarInformacion
  };
  return (
    <SubscripcionContext.Provider value={contextValue}>
      {children}
    </SubscripcionContext.Provider>
  );
};


SubscripcionContextProvider.propTypes = {
  children: PropTypes.node
};

export { SubscripcionContext, SubscripcionContextProvider };
 